import React from "react";
import CalendarDayCell from "./CalendarDayCell";

const CalendarGrid = ({
  days,
  dayNames,
  selectedDates,
  vacationDates,
  dateRangeStart,
  dateRangeEnd,
  dateRangeMode,
  getEventsForDate,
  styles,
  screenSize,
  language,
  t,
  onDateClick,
  onEventClick,
  onShowMoreEvents,
}) => {
  return (
    <div style={styles.calendarGrid}>
      {dayNames.map((day) => (
        <div key={day} style={styles.calendarDayHeader}>
          {screenSize.isMobile
            ? day.slice(0, language === "ar" ? 3 : 2)
            : day}
        </div>
      ))}

      {days.map((dayObj, index) => (
        <CalendarDayCell
          key={index}
          dayObj={dayObj}
          index={index}
          selectedDates={selectedDates}
          vacationDates={vacationDates}
          dateRangeStart={dateRangeStart}
          dateRangeEnd={dateRangeEnd}
          dateRangeMode={dateRangeMode}
          getEventsForDate={getEventsForDate}
          styles={styles}
          screenSize={screenSize}
          language={language}
          t={t}
          onDateClick={onDateClick}
          onEventClick={onEventClick}
          onShowMoreEvents={onShowMoreEvents}
        />
      ))}
    </div>
  );
};

export default CalendarGrid;
